export const css = {
    root: '_2mj4LYx_',
    question: '_3jAFLHsY',
    feedback: '_2PoJDVFS',
    rationale: '_2miTdUOW',
    fmi: '_3of__bMB',
    distractorBlock: '_22WW5l98',
    distractorFieldset: 'AmRdEslS',
    distractorLegend: '_2yH-23Ap',
    distractor: '_3Lxv1NK7',
    distractorLabel: '_37Oy4WP4',
    distractorWithFlag: '_8frfPrxo',
    distractorHint: '_2Ydyw70v',
    actions: '_1hKwOrcb',
    oneaction: '_10rI379Q',
    markblock: '_3eKMm7EO',
    timerblock: '_1D5BDL0l',
    timer: 'QGWmydTU',
    pressed: '_2FO5ARae',
    primaryButton: '_2_8D8u2Q',
    ' _key': 'afcpe-theme/afcpe/micro/quiz-widgets/mcquestion'
};
export default css;
